const ticketTypes = [
  {
    text: "four",
    switcherText: "4",
    count: 4,
    price: 14000
  },
  {
    text: "eight",
    switcherText: "8",
    count: 8,
    price: 23000
  },
  {
    text: "tvelve",
    switcherText: "12",
    count: 12,
    price: 30000
  },
/*  {
    text: "tventyfour",
    switcherText: "24",
    count: 24,
    price: 45000
  }*/
];

export default ticketTypes;